module.exports = __webpack_public_path__ + "static/media/TURFBOSS.a568a944.jpg";